// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"Sk-z","hovered":"Tk-z","hoverImage":"Uk-z","mainImage":"Vk-z","imageNoBackground":"Wk-z","fullSizeImage":"Xk-z"};